import {
  setMilliseconds,
  setSeconds,
  setMinutes,
  setHours,
  format,
  parse,
  getUnixTime,
} from "date-fns";

//called in create dispatch
export const setDateToZeroHours = (date) => {
  const newHours = setHours(date, 0);
  const newMin = setMinutes(newHours, 0);
  const newSeconds = setSeconds(newMin, 0);
  const newMillis = setMilliseconds(newSeconds, 0);
  return newMillis;
};

export const setDateToOneAm = (date) => {
  const newHours = setHours(date, 1);
  const newMin = setMinutes(newHours, 0);
  const newSeconds = setSeconds(newMin, 0);
  const newMillis = setMilliseconds(newSeconds, 0);
  return newMillis;
};

//called in ClientActivityPage
export const getFormattedTime = (date) => {
  if (Object.prototype.toString.call(date) === "[object Date]") {
    const newDateTime = format(date, "h:mm:ss aaa");
    return newDateTime;
  } else {
    const newDate = date.toDate();
    const newTime = format(newDate, "h:mm:ss aaa");
    return newTime;
  }
};

//called in EquipmentList
export const getFormattedDate = (date) => {
  if (date === null || date === undefined) {
    return "Not done yet";
  }
  
  try {
    if (Object.prototype.toString.call(date) === "[object Date]") {
      const newDateTime = format(date, "MMM, dd, yyyy");
      return newDateTime;
    } else if (typeof date.toDate === 'function') {
      const newDate = date.toDate();
      const newTime = format(newDate, "MMM, dd, yyyy");
      return newTime;
    } else {
      return "Not done yet";
    }
  } catch (error) {
    console.warn("Error formatting date:", date, error);
    return "Not done yet";
  }
};

export const getFormattedYear = (date) => {
  if (date === null || date === undefined) {
    return "Not A Date";
  }
  
  try {
    if (Object.prototype.toString.call(date) === "[object Date]") {
      const newDateTime = format(date, "yyyy");
      return newDateTime;
    } else if (typeof date.toDate === 'function') {
      const newDate = date.toDate();
      const newTime = format(newDate, "yyyy");
      return newTime;
    } else {
      return "Not A Date";
    }
  } catch (error) {
    console.warn("Error formatting year:", date, error);
    return "Not A Date";
  }
};

//called in warranty list
export const getWarrantyFormattedDate = (date) => {
  if (date === null || date === undefined) {
    return "None On Record";
  }
  
  try {
    if (Object.prototype.toString.call(date) === "[object Date]") {
      const newDateTime = format(date, "MMM, dd, yyyy");
      return newDateTime;
    } else if (typeof date.toDate === 'function') {
      const newDate = date.toDate();
      const newTime = format(newDate, "MMM, dd, yyyy");
      return newTime;
    } else {
      return "None On Record";
    }
  } catch (error) {
    console.warn("Error formatting warranty date:", date, error);
    return "None On Record";
  }
};

//called in ClientActivity, and SupportingDocuments
export const getFormattedDateAndTime = (date) => {
  if (date === null || date === undefined) {
    return "Not done yet";
  }
  
  try {
    if (Object.prototype.toString.call(date) === "[object Date]") {
      const newDateTime = format(date, "MMM, dd, yyyy h:mm:ss aaa");
      return newDateTime;
    } else if (typeof date.toDate === 'function') {
      const newDate = date.toDate();
      const newTime = format(newDate, "MMM, dd, yyyy h:mm:ss aaa");
      return newTime;
    } else {
      return "Not done yet";
    }
  } catch (error) {
    console.warn("Error formatting date and time:", date, error);
    return "Not done yet";
  }
};

export const getFormattedExactTime = (date) => {
  if (date === null || date === undefined) {
    return "Not done yet";
  }
  
  try {
    if (Object.prototype.toString.call(date) === "[object Date]") {
      const exactTimeFormat = format(date, "MMM, dd, yyyy h:mm:ss:T");
      return exactTimeFormat;
    } else if (typeof date.toDate === 'function') {
      const newDate = date.toDate();
      const exactTimeFormat = format(newDate, "MMM, dd, yyyy h:mm:ss:T");
      return exactTimeFormat;
    } else {
      return "Not done yet";
    }
  } catch (error) {
    console.warn("Error formatting exact time:", date, error);
    return "Not done yet";
  }
};

export const getFormattedCompactDateAndTime = (date) => {
  if (Object.prototype.toString.call(date) === "[object Date]") {
    const exactTimeFormat = format(date, "MM/dd/yy h:mm");
    return exactTimeFormat;
  } else {
    const newDate = date.toDate();
    const exactTimeFormat = format(newDate, "MM/dd/yy h:mm a");
    return exactTimeFormat;
  }
};

export const timestampToDateTime = (timestamp) => {
  if (Object.prototype.toString.call(timestamp) === "[object Date]") {
    const exactTimeFormat = format(timestamp, "MM/dd/yy h:mm a");
    return exactTimeFormat;
  } else {
    const fireBaseTime = new Date(
      timestamp.seconds * 1000 + timestamp.nanoseconds / 1000000
    );
    const exactTimeFormat = format(fireBaseTime, "MM/dd/yy h:mm a");
    return exactTimeFormat;
  }
};

export const timestampToDate = (timestamp) => {
  if (Object.prototype.toString.call(timestamp) === "[object Date]") {
    const exactTimeFormat = format(timestamp, "MMM/dd/yyyy");
    return exactTimeFormat;
  } else {
    const fireBaseTime = new Date(
      timestamp.seconds * 1000 + timestamp.nanoseconds / 1000000
    );
    const exactTimeFormat = format(fireBaseTime, "MMM/dd/yyyy");
    return exactTimeFormat;
  }
};

export const getDateFromString = (string) => {
  return parse(string, "MMM, dd, yyyy", new Date());
};

export const getUnixFromDate = (date) => {
  return getUnixTime(date);
};
